var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"case-study-block-image",style:({backgroundImage: 'url(' + _vm.image + ')'}),domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }